module.exports = __webpack_public_path__ + "img/monitoringdescription1.760e80f5.png";